module.exports = {
	"payment_methods.title": "Vos moyens de paiement",
	"payment_methods.empty": "Vous n'avez pas de moyens de paiement",
	"payment_methods.delete": "Effacer",
	"payment_methods.payment_method": "Moyen de paiement",
	"login.title": "Identifiant ",
	"login.register": "Inscription ",
	"login.login": "S'identifier ",
	"form.email": "Courriel ",
	"form.password": "Mot de passe",
	"form.password_confirmation": "Confirmation du mot de passe",
	"form.remember_me": "Se souvenir de moi",
	"form.forgot_password": "Mot de passe oublié ?",
	"subscriptions.title": "Vos don récurrents ",
	"subscriptions.no_donations": "Vous n'avez aucun don récurrent ",
	"subscriptions.created": "Créé le",
	"subscriptions.donation_amount": "Montant du don",
	"subscriptions.donation_count": "Nombre de transaction ",
	"subscriptions.cancel": "ANNULER",
	"subscriptions.cancel_confirm": "Êtes-vous sûr de vouloir annuler votre don récurrent ?",
	"menu.recurring_donations": "Dons récurrents",
	"menu.payment_methods": "Moyens de paiement",
	"menu.sign_out": "Déconnection ",
	"registration.register": "Inscription",
	"registration.registering": "Inscription en cours...",
	"registration.required": "Requis",
	"registration.invalid_email": "Adresse courriel incorrecte ",
	"registration.password_mismatch": "Les mots de passe sont différents ",
	"registration.password_length": "Doit contenir au moins 6 caractères"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/react-intl/locales/fr.json
 ** module id = 948
 ** module chunks = 0
 **/